export class Navbar {
  navbar: HTMLElement;
  mobileNavbar: HTMLElement;
  hamburgerMenuButtons: HTMLButtonElement[] = [];

  constructor() {
    this.navbar = document.querySelector('[data-navbar]')!;
    this.mobileNavbar = document.querySelector('[data-mobile-navbar]')!;

    this.hamburgerMenuButtons = Array.from(this.navbar.querySelectorAll('[data-hamburger-menu-button]')!);
    this.bindEvents();
  }

  private bindEvents() {
    for (const button of this.hamburgerMenuButtons) {
      button.addEventListener('click', () => {
        this.mobileNavbar.classList.toggle('hidden');
      });
    }
  }
}
